document.addEventListener('DOMContentLoaded', () => {
  const slideShows = document.querySelectorAll('.block-group-slide-show');

  if (slideShows.length > 0) {
    const outerContainer = document.createElement('div');
    outerContainer.classList.add('block-group-slide-show-container');
    [...slideShows].forEach(slideShow => {
      const container = slideShow.querySelector(
        '.wp-block-group__inner-container'
      );

      slideShow.parentNode.insertBefore(outerContainer, slideShow);

      outerContainer.appendChild(slideShow);

      const slides = container.querySelectorAll('.wp-block-media-text');

      const hasNextPreviousButtons = true;
      const hasJumpButtons = true;
      const endlessLoop = true;
      const enableSwipeGestures = true;
      const showButtonText = false;
      const count = slides.length;
      let timer, restartTimer, mouseX, nextBtn, previousBtn;
      let wrapDirection = false;
      let curr = 0;

      const transition = 'transform 400ms ease-in';

      let jumpBtns;
      if (hasJumpButtons) {
        jumpBtns = document.createElement('div');
        jumpBtns.classList.add('slide-jump-btns');
      }

      if (endlessLoop) {
        container.appendChild(slides[0].cloneNode(true));
        container.prepend(slides[count - 1].cloneNode(true));
      }

      loop();

      function loop() {
        timer = setInterval(() => {
          container.style.transition = transition;
          dispatch('auto-next');
        }, 4000);
      }

      setTimeout(() => {
        slideShow.style.opacity = 1;
      }, 500);

      function dispatch(action, payload) {
        const {
          nextSlide,
          previousSlide,
          swipeNext,
          swipePrevious,
          jumpSlide
        } = computeNextPreviousSlides(payload);
        let newState;
        let pauseLoop = false;

        container.style.transition = transition;
        switch (action) {
          case 'start':
            newState = nextSlide;
            break;
          case 'auto-next':
            newState = nextSlide;
            break;
          case 'next':
            newState = nextSlide;
            pauseLoop = true;
            break;
          case 'previous':
            newState = previousSlide;
            pauseLoop = true;
            break;
          case 'swipe-next':
            newState = swipeNext;
            pauseLoop = true;
            break;
          case 'swipe-previous':
            newState = swipePrevious;
            pauseLoop = true;
            break;
          case 'jump':
            newState = jumpSlide;
            pauseLoop = true;
            break;
          case 'window-resize':
            break;
        }
        curr = newState;

        container.style.transform = `translateX(${container.offsetWidth *
          -curr}px)`;

        if (endlessLoop) handleWrapAround(newState);

        if (pauseLoop) {
          clearInterval(timer);
          clearTimeout(restartTimer);
          restartTimer = setTimeout(loop, 5000);
        }
      }

      function computeNextPreviousSlides(payload) {
        let nextSlide, previousSlide;
        if (endlessLoop) {
          nextSlide = curr <= count ? parseInt(curr) + 1 : 0;
          previousSlide = curr > 0 ? parseInt(curr) - 1 : count - 1;
        } else {
          nextSlide = curr < count - 1 ? parseInt(curr) + 1 : 0;
          previousSlide = curr > 0 ? parseInt(curr) - 1 : count - 1;
        }

        let swipeNext = nextSlide;
        if (!endlessLoop && swipeNext === 0) swipeNext = curr;

        let swipePrevious = previousSlide;
        if (!endlessLoop && previousSlide === count - 1) swipePrevious = curr;

        let jumpSlide;
        if (payload && payload.hasOwnProperty('idx')) {
          jumpSlide = endlessLoop ? payload.idx + 1 : payload.idx;
        }

        return {
          nextSlide,
          previousSlide,
          swipeNext,
          swipePrevious,
          jumpSlide
        };
      }

      function handleWrapAround(newState) {
        wrapDirection = false;
        if (newState > count) wrapDirection = 'beginning';
        if (newState <= 0) wrapDirection = 'end';
      }

      container.addEventListener('transitionend', () => {
        switch (wrapDirection) {
          case 'beginning':
            container.style.transition = '';
            container.style.transform = `translateX(${container.offsetWidth *
              -1}px)`;
            curr = 1;
            break;
          case 'end':
            container.style.transition = '';
            container.style.transform = `translateX(${container.offsetWidth *
              -count}px)`;
            curr = count;
            break;
        }

        /* if (hasJumpButtons) {
          [...jumpBtns.querySelectorAll('button')].forEach((btn, idx) => {
            btn.classList.remove('active');
            if (hasJumpButtons) {
              [...jumpBtns.querySelectorAll('button')].forEach((btn, idx) => {
                btn.classList.remove('active'); 
                if (idx === curr) btn.classList.add('active');
              });
            }
          });
        } */
      });

      if (hasNextPreviousButtons) {
        nextBtn = createButton('Next', 'next', {
          classList: ['slide-arrow', 'slide-arrow-next']
        });
        slideShow.appendChild(nextBtn);

        previousBtn = createButton('Previous', 'previous', {
          classList: ['slide-arrow', 'slide-arrow-previous']
        });
        slideShow.appendChild(previousBtn);
      }

      if (hasJumpButtons) {
        [...slides].forEach((_, idx) => {
          const btn = createButton(idx + 1, 'jump', { idx: idx });
          //if (idx === 0) btn.classList.add('active');
          jumpBtns.appendChild(btn);
        });

        slideShow.appendChild(jumpBtns);
      }

      window.addEventListener('resize', () => dispatch('window-resize'));

      if (enableSwipeGestures) {
        container.addEventListener('mousedown', swipeStart, false);
        container.addEventListener('touchstart', swipeStart, false);

        container.addEventListener('mouseup', swipeEnd, false);
        container.addEventListener('touchend', swipeEnd, false);
      }

      function swipeStart(e) {
        e.preventDefault();
        mouseX = event.clientX;
      }

      function swipeEnd(e) {
        e.preventDefault();
        const diff = mouseX - event.clientX;
        let direction = false;
        if (diff > 100) direction = 'swipe-next';
        if (diff < -100) direction = 'swipe-previous';

        if (direction !== false) dispatch(direction);
      }

      function createButton(text = '', action, payload = {}) {
        let btn = document.createElement('button');
        btn.type = 'button';
        payload.classList &&
          payload.classList.forEach(className => btn.classList.add(className));
        if (showButtonText) btn.textContent = text;
        btn.addEventListener('click', _ => dispatch(action, payload));
        return btn;
      }
    });
  }

  function prefersReducedMotion() {
    if (
      'matchMedia' in window &&
      window.matchMedia('(prefers-reduced-motion)').matches
    ) {
      return true;
    }
    return false;
  }
});
